import { useEffect, useState } from 'react';

export const useDefaultTheme = () => {
  const [defaultTheme, setDefaultTheme] = useState(() => {
    if (typeof window === 'undefined') {
      return 'light';
    }

    // Check URL parameters
    const params = new URLSearchParams(window.location.search);
    const urlTheme = params.get('theme') as 'light' | 'dark' | null;

    if (urlTheme === 'dark' || urlTheme === 'light') {
      return urlTheme;
    }

    // Fall back to system preference
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (event: MediaQueryListEvent) => {
      setDefaultTheme(event.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return defaultTheme;
};
